mutation RequestTwitchAuthUrl {
  authUrl: StreamToolsRequestTwitchAuthUrl {
    url
    state
    expiresAt
  }
}
